/**
 * Attempt to fetch a filtered list of articles for a
 */
export default class RelatedArticles extends HTMLElement {
  constructor() {
    super();

    this.listNode = this.querySelector("[data-ref='list']");
    this.viewAllNode = this.querySelector("[data-ref='view-all']");
  }

  connectedCallback() {
    if (!this.fetchUrl || !this.listNode) return;

    fetch(this.fetchUrl)
      .then((response) => response.text())
      .then((response) => {
        const parser = new DOMParser();

        const responseDoc = parser.parseFromString(response, "text/html");
        const responseListItems = responseDoc?.querySelectorAll(
          "ul[data-ref='article-grid'] > li",
        );

        if (!responseListItems?.length) return;

        const slicedList = Array.from(responseListItems).slice(0, this.limit);
        // append items to existing list
        for (const item of slicedList) {
          const heading = item.querySelector("h2");
          heading.setAttribute("aria-level", "3");
          this.listNode.appendChild(item);
        }

        // create viewAllLink href and show if more articles than visible limit
        const viewAllLink = this.viewAllNode?.querySelector("a");
        if (viewAllLink && responseListItems.length > this.limit) {
          viewAllLink.setAttribute("href", this.fetchUrl);
          this.viewAllNode.removeAttribute("hidden");
        }

        this.removeAttribute("inert");
      })
      .catch((error) => console.warn(error));
  }

  get blog() {
    return this.dataset.blog;
  }

  get tag() {
    return this.dataset.tag;
  }

  get limit() {
    return 3;
  }

  get fetchUrl() {
    if (!this.blog || !this.tag) return null;
    return `/blogs/${this.blog}/tagged/${this.tag}`;
  }
}
